import { render, staticRenderFns } from "./CustomDisplayElementDraggable.vue?vue&type=template&id=32f1388d&scoped=true&lang=html"
import script from "./CustomDisplayElementDraggable.vue?vue&type=script&lang=js"
export * from "./CustomDisplayElementDraggable.vue?vue&type=script&lang=js"
import style0 from "./CustomDisplayElementDraggable.vue?vue&type=style&index=0&id=32f1388d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f1388d",
  null
  
)

export default component.exports